import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from '../auth/components/login-form/login-form.component';
import { RequestQrCodeComponent } from './components/request-qr-code/request-qr-code.component';

const routes: Routes = [
  {
    path: 'login',
    children: [
      {path: '', component: LoginFormComponent},
      {path: 'request-qr', component: RequestQrCodeComponent},
      {path: '**', redirectTo: ''}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
